(function () {
    const MAX_WAIT_MS = 10000;
    const POLL_INTERVAL_MS = 200;

    function normalizeHash(hash) {
        if (!hash) return '';
        return hash.startsWith('#') ? hash.slice(1) : hash;
    }

    function getTargetElement(id) {
        if (!id) return null;
        return document.getElementById(id) || document.querySelector(`[name="${id}"]`);
    }

    function scrollToElement(el, options = { behavior: 'smooth', block: 'start' }) {
        try {
            if (!el) return false;
            el.scrollIntoView(options);
            return true;
        } catch (e) {
            try {
                window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY, behavior: options.behavior });
                return true;
            } catch (err) {
                return false;
            }
        }
    }

    function tryScrollHash(hash) {
        const id = normalizeHash(hash || location.hash);
        if (!id) return false;
        const el = getTargetElement(id);
        if (el) {
            const behavior = window.__DISABLE_SMOOTH_SCROLLING__ ? 'auto' : 'smooth';
            return scrollToElement(el, { behavior, block: 'start' });
        }

        return false;
    }

    function ensurePendingHash(hash) {
        const id = normalizeHash(hash || location.hash);
        if (!id) return;
        if (!tryScrollHash('#' + id)) {
            window.__pendingHash = '#' + id;
            startWatchForId(id);
        }
    }

    let _observer = null;
    let _watchTimeout = null;
    function startWatchForId(id) {
        if (!id) return;
        if (_observer) return;

        const start = Date.now();

        const poll = setInterval(() => {
            const el = getTargetElement(id);
            if (el) {
                tryScrollHash('#' + id);
                clearInterval(poll);
                disconnectObserver();
            }
            if (Date.now() - start > MAX_WAIT_MS) {
                clearInterval(poll);
                disconnectObserver();
            }
        }, POLL_INTERVAL_MS);

        _observer = new MutationObserver(() => {
            const el = getTargetElement(id);
            if (el) {
                tryScrollHash('#' + id);
                clearInterval(poll);
                disconnectObserver();
            }
        });

        _observer.observe(document.body, { childList: true, subtree: true });

        _watchTimeout = setTimeout(() => {
            clearInterval(poll);
            disconnectObserver();
        }, MAX_WAIT_MS);
    }

    function disconnectObserver() {
        if (_observer) {
            try {
                _observer.disconnect();
            } catch (e) {}
            _observer = null;
        }
        if (_watchTimeout) {
            clearTimeout(_watchTimeout);
            _watchTimeout = null;
        }
        window.__pendingHash = null;
    }

    window.addEventListener('data-loaded', (ev) => {
        const id = ev?.detail?.id ? normalizeHash(ev.detail.id) : normalizeHash(location.hash);
        if (!id) return;
        tryScrollHash('#' + id);
    });

    document.addEventListener('DOMContentLoaded', () => {
        if (location.hash) {
            ensurePendingHash(location.hash);
        }
    });

    document.addEventListener('livewire:load', () => {
        try {
            Livewire.hook('message.processed', () => {
                if (window.__pendingHash) {
                    if (tryScrollHash(window.__pendingHash)) {
                        window.__pendingHash = null;
                        disconnectObserver();
                    }
                }
            });
        } catch (e) {}
    });

    if (document.readyState === 'complete' && location.hash) {
        ensurePendingHash(location.hash);
    }
})();


